import React, { useEffect, useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { DeletePopUp, EmptyCollection, ExportMenu, FilterComponent, ImportMenu, PageLoader, Pagination, RevisionHistory, STableLoader, } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPutService } from "../../../../globalServices";
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import ManufacturersList from "../components/ManufacturersList";
import AddEditManufacturers from "../components/AddEditManufacturers";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import DeploymentMessage from "../../../../shared/components/DeploymentMessage";
import AddIcon from '@material-ui/icons/Add';
import { usePageTitleOffset } from '../../../elements/CollapsibleSideNav';

const ManufacturersObj = {
	name: null,
	address: null,
	remarks: null,
}

const ManufacturersHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo }) => {
	return (
		<TableHead>
			<TableRow >
				<TableCell>{checkPermission('config_data', 'manufacturers', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'name' ? true : false}
						direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('name')}
					>
						Name
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'address' ? true : false}
						direction={sortInfo.sort === 'address' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('address')}
					>
						Address
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'created_by' ? true : false}
						direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('created_by')}
					>
						Created By
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'updated_by' ? true : false}
						direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('updated_by')}
					>
						Last Updated By
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'remarks' ? true : false}
						direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('remarks')}
					>
						Remarks
					</TableSortLabel>
				</TableCell>
			</TableRow>
		</TableHead>
	)
}

const Manufacturers = () => {
	const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [isLoading, setLoading] = useState(false);
	const [isBannerActive, setIsBannerActive] = useState(false);
	const [filter, setFilter] = useState({});
	const [pageSelections, setPageSelections] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
	const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
	const [addEditManufacturers, setAddEditManufacturers] = useState({ modal: false, data: null });
	const [deleteManufacturers, setDeleteManufacturers] = useState({ modal: false, data: null });
	const [revertManufacturers, setRevertManufacturers] = useState({ modal: false, data: null });
	const [manufacturersInfo, setManufacturersInfo] = useState({ list: [], pagination: {} });

	useEffect(() => {
		getManufacturers({ per_page: 50 }, "skeletonLoader");
		trackActivity('Console Management', { page_title: 'Config Data : Manufacturers', event_type: 'Page Visited' })
	},[])

	const getManufacturers = (query = {}, loaderType) => {
		loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
		globalGetService(`config-data/manufacturers/`, query)
			.then(response => {
				if (checkApiStatus(response)) {
					setManufacturersInfo(response?.data?.data)
					if (query) {
						delete query.page
						delete query.per_page
						delete query.sort
						delete query.sort_by
						setFilter(query)
					}
				}
				loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
			})
	}

	const toggleBulkOps = (item, checked, currentPage) => {
		setPageSelections(prevSelections => {
			const updatedSelections = { ...prevSelections };
			if (checked) {
				updatedSelections[currentPage] = updatedSelections[currentPage] || [];
				updatedSelections[currentPage].push(item?.id);
			} else {
				updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
			}
			return updatedSelections;
		});
	};

	const onDelete = () => {
		setLoading(true);
		const ids = !deleteManufacturers.data ? Object.values(pageSelections).flat().filter(id => {
			const item = manufacturersInfo.list.find(item => item.id === id);
			return item && !item.deleted_at;
		}) : deleteManufacturers.data.id

		globalDeleteService(`config-data/manufacturers/bulk-delete/`, { ids })
			.then(response => {
				if (checkApiStatus(response)) {
					setDeleteManufacturers({ modal: false, data: null });
					getManufacturers({...filter, page: manufacturersInfo?.pagination?.page, per_page: manufacturersInfo?.pagination?.per_page}, 'pageLoader');
					setCurrentPage({});
					setLoading(false);
					setPageSelections({});
					setBulkDelete({ modal: false, data: null })
					enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : Manufacturers',
						event_type: `Item Deleted`,
						event_desc: 'Manufacturers Deleted Successfully',
						success_msg: response?.data?.message,
						deleted_id: ids
					});
				} else {
					setDeleteManufacturers({ modal: false, data: null });
					setLoading(false);
					setPageSelections({});
					setBulkDelete({ modal: false, data: null })
					enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : Manufacturers',
						event_type: `Item Deleted`,
						event_desc: 'Manufacturers Deletion Failed',
						error_msg: response?.data?.message,
						item_id: ids
					});
				}
			});
	};

	const onRevert = () => {
		setLoading(true);
		const ids = !revertManufacturers.data ? Object.values(pageSelections).flat().filter(id => {
			const item = manufacturersInfo.list.find(item => item.id === id);
			return item && item.deleted_at;
		}) : revertManufacturers.data;

		globalPutService(`config-data/manufacturers/restore/`, { ids })
			.then(response => {
				if (checkApiStatus(response)) {
					setRevertManufacturers({ modal: false, data: null });
					getManufacturers({...filter, page: manufacturersInfo?.pagination?.page, per_page: manufacturersInfo?.pagination?.per_page}, 'pageLoader');
					setCurrentPage({});
					setLoading(false);
					setPageSelections({});
					setBulkRevert({ modal: false, data: null })
					enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : Manufacturers',
						event_type: `Item Reverted`,
						event_desc: 'Manufacturers Reverted Successfully',
						success_msg: response?.data?.message,
						reverted_id: ids
					});
				} else {
					setRevertManufacturers({ modal: false, data: null });
					setLoading(false);
					setPageSelections({});
					setBulkRevert({ modal: false, data: null })
					enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : Manufacturers',
						event_type: `Item Reverted`,
						event_desc: 'Manufacturers Reversion Failed',
						error_msg: response?.data?.message,
						item_id: ids
					});
				}
			});
	};

	const handleSelectAll = (event, currentPage) => {
		if (event?.target.checked) {
			const allIds = manufacturersInfo?.list.map(item => item.id);
			setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
		} else {
			setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
		}
	};

	const getFilteredSelectionCounts = () => {
		let deleteCount = 0;
		let revertCount = 0;

		if (pageSelections[currentPage]?.length) {
			pageSelections[currentPage].forEach(id => {
				const selectedItem = manufacturersInfo?.list?.find(item => item?.id === id);
				if (selectedItem) {
					if (selectedItem?.deleted_at) {
						revertCount++;
					} else {
						deleteCount++;
					}
				}
			});
		}
		return { deleteCount, revertCount };
	};

	const { deleteCount, revertCount } = getFilteredSelectionCounts();

	const createSortHandler = (key) => {
		let sortQuery = { sort: key };
		if (sortInfo.sort === key) {
			sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
		} else {
			sortQuery = { ...sortQuery, sort_by: 'asc' }
		}
		setSortInfo(sortQuery)
		getManufacturers({ ...filter, ...sortQuery, page: 1, per_page: manufacturersInfo?.pagination?.per_page || 20 }, 'pageLoader');
	}

	const isSelectAllChecked = manufacturersInfo?.list?.length > 0 && pageSelections[currentPage]?.length === manufacturersInfo?.list?.length;

	const getConfirmColor = () => {
        if (revertManufacturers?.modal || bulkRevert?.modal) return "primary";
        if (deleteManufacturers?.modal || bulkDelete?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertManufacturers?.modal || bulkRevert?.modal) return "Revert";
        if (deleteManufacturers?.modal || bulkDelete?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertManufacturers?.modal) return revertManufacturers.modal;
        if (deleteManufacturers?.modal) return deleteManufacturers.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        return null;
    };

    const getTitle = () => {
        if (revertManufacturers?.modal) return "Revert Manufacturers";
        if (deleteManufacturers?.modal) return "Delete Manufacturers";
        if (bulkDelete?.modal) return `Delete Manufacturers (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Manufacturers (${revertCount})`;
        return "";
    };

    const getContent = () => {
        if (revertManufacturers?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteManufacturers?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertManufacturers?.modal) {
            setRevertManufacturers({ modal: false, data: null });
        } else if (deleteManufacturers?.modal) {
            setDeleteManufacturers({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else {
            setBulkRevert({ modal: false, data: null });
        } 
    };


    const getDeleteRecordFn = () => {
        if (revertManufacturers?.modal || bulkRevert?.modal) return onRevert;
        if (deleteManufacturers?.modal || bulkDelete?.modal) return onDelete;
        return null;
    };

	const filterOption = (
		{
			'name': {
				'inputType': 'text',
				'title': 'Name',
			},
		})

	return (
		<section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
			<DeploymentMessage onStatusChange={setIsBannerActive} />
			<Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - (isBannerActive ? 129 : 89)}px` }}>
				<ConfigData />
				<div className="tech-specs-content" style={{ paddingTop: '0px' }}>
					{skeletonLoader ? <STableLoader count={6} size={9} /> :
					<div style={{ padding: '10px' }}>
						<Paper elevation={0} className="console-paper" style={{ padding: '4px 8px', marginBottom: "2px" }}>
							<Grid container spacing={1} alignItems="center">
								<Grid item md={6}>
											<FilterComponent
												filter={filter}
												filterMenu={filterOption}
												getResponseBack={(applyFilter) => { getManufacturers({ ...applyFilter, page: 1, per_page: manufacturersInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
											/>					
								</Grid>
								<Grid item md={6}>
									<ul className='list-inline flex-centered' style={{ float: 'right' }}>
										{revertCount > 0 && (
											<li className='list-inline-item'>
												<Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Manufacturers', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Manufacturers` }) }} color="primary" size='small' variant="outlined">
													Revert ({revertCount})
												</Button>
											</li>
										)}
										{deleteCount > 0 && (
											<li className='list-inline-item'>
												<Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Manufacturers', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Manufacturers` }) }} color="secondary" size='small' variant="contained">
													Delete ({deleteCount})
												</Button>
											</li>
										)}
										{checkPermission('config_data', 'manufacturers', 'C') && <li className='list-inline-item'>
											<Button onClick={() => setAddEditManufacturers({ modal: true, data: ManufacturersObj })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
										</li>}
										<li className='list-inline-item' style={{ cursor: 'pointer' }}>
											<RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdmanufacturers/`} queryParams={{ action: '0,1,2' }} />
										</li>
									</ul>
								</Grid>
							</Grid>
						</Paper>
						<Paper square>
							<div style={{ height: `${(window.innerHeight - (manufacturersInfo?.list?.length ? 200 : 150) - (isBannerActive ? 40 : 0)) - navTitleOffset}px`, overflow: 'auto' }}>
							<Table className='mui-table-format' stickyHeader>
								<ManufacturersHeader isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
									<TableBody>
										{manufacturersInfo?.list?.length > 0 && manufacturersInfo?.list?.map((item, index) =>
											<ManufacturersList
												item={item}
												index={index}
												onDelete={setDeleteManufacturers}
												onRevert={setRevertManufacturers}
												onEditFn={() => setAddEditManufacturers({ modal: true, data: item, type: 'edit' })}
												onViewFn={() => setAddEditManufacturers({ modal: true, data: item, type: 'view' })}
												toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
												bulkIds={pageSelections[currentPage] || []}
											/>
										)}
									</TableBody>
							</Table>
							{!manufacturersInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
							</div>
						</Paper>
						<Paper square>
							<Pagination
								pagination={manufacturersInfo?.pagination}
								onChangePage={(event, newPage) => { getManufacturers({ ...filter, page: newPage + 1, per_page: manufacturersInfo.pagination?.per_page }, 'pageLoader'); setCurrentPage(newPage + 1) }}
								onChangeRowsPerPage={(event) => getManufacturers({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
							/>
						</Paper>
					</div>}
				</div>
				{addEditManufacturers.modal ?
					<AddEditManufacturers
						addEditManufacturers={addEditManufacturers}
						manufacturersInfo={manufacturersInfo}
						toggleModalFn={() => setAddEditManufacturers({ modal: false, manufacturersData: [] })}
						getResponseBack={() => getManufacturers({...filter, page: manufacturersInfo?.pagination?.page, per_page: manufacturersInfo?.pagination?.per_page}, 'pageLoader')}
						modeType={addEditManufacturers?.type}
					/> : null
				}
				<DeletePopUp
					confirmColor={getConfirmColor()}
					confirmText={getConfirmText()}
					modal={getModal()}
					title={getTitle()}
					content={getContent()}
					toggleModalFn={toggleModalFn}
					deleteRecordFn={getDeleteRecordFn()}
				/>
			</Paper>
			{isLoading ? <PageLoader /> : null}
		</section>
	)
}
export default Manufacturers;